import React from 'react'
import './Servicios.css'
import TitleContentSection from '../titlecontentsection/TitleContentSection'
import MessageBox from '../messagebox/MessageBox'
import BaseComponent from '../basecomponent/BaseComponent'
import {ModalContainer, ModalDialog} from 'react-modal-dialog'
import 'font-awesome/css/font-awesome.css'

const firstListItems = [
    {
        name: "Conservadora",
        description: "<p>Es la parte de la odontología que nos permite tratar las caries en sus diferentes fases, desde la más inicial mediante los sellados de fisuras, hasta la que comporta destrucción del tejido dentario con la realización de obturaciones o reconstrucciones conocidos como “empastes”, pudiéndose utilizar los materiales más estéticos como el composite, pero sin descartar en algunas situaciones el uso de amalgamas de plata pese a su pérdida de popularidad.</p>"
    },{
        name: "Higiene bucal", 
        description: `<p>Es el procedimiento que se efectua en la consulta dental destinado a eliminar los acúmulos de sarro y cálculo que quedan retenidos sobre el diente y bajo 
        las encías, con el objetivo de mantener una buena salud dental y periodontal, minimizando así el riesgo de caries y problemas periodontales.<br>
        Se recomienda que sea practicado al menos una vez al año (dependiendo de la cantidad de sarro y placa bacteriana que se depositen sobre los dientes) y de la 
        habilidad de cada persona para cepillarse.<br>
        Habitualmente es realizado por las higienistas de la clínica dental, pero en algunos casos especiales ésta es realzada por el doctor.<br><br>

        Suele consistir en la eliminación de cálculo y sarro mediante un aparato de ultrasonidos, ayudado en ocasiones con la utilizacion de curetas periodontales.<br> 
        En caso que el paciente sufra problemas gingivales previos es posible que tenga las piezas mas sensibles, por lo que en ocasiones se debe usar un anestésico 
        local para que el procedimiento no sea molesto, o incluso realizarse en varias sesiones.<br>
        También se usa seda dental para eliminar los restos interproximales, y finalmente se realiza un cepillado con una pasta de pulido que ayuda a eliminar las 
        manchas superficiales que puedan tener los dientes.<br><br>

        Una vez realizada la higiene, y según las necesidades de cada paciente, la higienista le aconsejará si precisa alguna pasta dentífrica o colutorio especial 
        para ayudar al cuidado y mantenimiento de sus dientes y encías.<br><br>

        Por supuesto, puede haber situaciones mas graves o avanzadas que requieran de un tratamiento más complejo, el cual puede llegar incluso a la cirugía, 
        pero éste ya debe ser realizado por especialistas periodontales.</p>`
    },{
        name:"Endodoncia", 
        description: `<p>Se refiere al acto médico mediante el cual se accede a la pulpa o nervio del diente para extraerla, es decir, desvitalizar la pieza.<br>
        El tratamiento endodóntico es necesario cuando la pulpa se inflama o se infecta.<br>
        Puede haber diferentes causas de infección o inflamación:</p>
        <ul>
        <li>Caries profunda</li>
        <li>Repetición de procedimientos dentales sobre el mismo diente</li>
        <li>Problemas periodontales o de encía</li>
        </ul>
        <p>Incluso una fisura o fractura del diente por sobrecarga o traumatismo también puede hacerle daño a la pulpa aún cuando éste no sea visible.<br><br>
        
        Si no se trata la inflamación o la infección de la pulpa, puede causar dolor o formarse un absceso.<br>
        
        Las señales que nos indican que la pulpa está dañada incluyen:</p>
        
        <ul>
        <li>Dolor</li>
        <li>Sensibilidad prolongada al frío o al calor</li>
        <li>Cambios de color</li>
        <li>Hinchazón y molestia en la encía alrededor del diente</li>
        </ul>
        
        <p>Sin embargo, en posible que en ocasiones no se presente ninguna sintomatología.<br><br>
        
        El doctor elimina la pulpa inflamada o infectada, limpia y prepara el interior del diente con cuidado, obtura, y sella el espacio remanente.<br>
        Para este proceso pueden ser necesarias varias sesiones hasta conseguir el resultado deseado, dependiendo de la situación inicial o de la anatomía de las raíces.<br>
        
        Finalmente el dentista realizará la reconstrucción de la pieza con un refuerzo interno (poste, pin, etc.) si lo considera preciso, e indicará si es necesaria 
        una corona para proteger mejor el diente y devolverle su función, pues las piezas desvitalizadas pueden ser mas susceptibles de fractura, sobretodo en pacientes bruxistas.</p>`
    },{
        name:"Prótesis removible", 
        description: `<p>Se refiere a los elementos artificiales diseñados para restaurar la anatomía y función de las piezas ausentes del maxilar superior o inferior.<br><br>
        
        Este tipo de prótesis pueden ser:</p>
        
        <ul>
        <li>Parciales, si faltan solo algunas piezas</li>
        <li>Completas, cuando están ausentes todas las piezas</li>
        </ul>
        <br><p>Suelen estar confeccionadas con un material acrílico de resina, y también pueden tener una parte metálica con retenedores o ganchos que 
        mejoran la estabilidad de la prótesis en su zona de asentamiento, ya que no son fijas y se deben retirar para una correcta higiene.</p>`
    },{
        name:"Prótesis fija",
        description: `<p>Este tipo de prótesis está diseñada para ir cementada en boca sobre un pilar que, habitualmente, se trata de una pieza natural que ha sido modificada (tallada)
        para poder asentar la corona o funda artificial.<br><br>
        
       Si abarca  más de una pieza hablaríamos de puentes fijos, pues se asienta en diferentes pilares con espacios edéntulos intermedios.<br><br>
       
       Los materiales en los que se realizan son variados, y pueden ser completamente metálicos o de cerámica, e incluso en la actualidad también existen otros 
       materiales que permiten ofrecer mejor estética como el zirconio.<br><br>
       
       En este apartado también podríamos incluir las prótesis atornilladas sobre implantes que previamente se han colocado en el hueso, aumentando el abanico de 
       posibilidades a la hora de rehabilitar un espacio edéntulo. Esta prótesis no puede ser retirada por el paciente una vez colocada</p>`
    }
]

const secondListItems = [
    {
        name:"Implantes", 
        description: `<p>La implantología es el conjunto de técnicas que constan de una primera fase quirúrgica y una segunda fase protésica, 
        las cuales permiten la <span>reposición de dientes ausentes</span> (uno, varios o todos) mediante la colocación de elementos de titanio de altísima pureza en el 
        hueso maxilar superior, inferior o en ambos; y que <span>tras un periodo de tiempo variable</span> (según la calidad del hueso receptor), <span>se osteointegran.</span><br><br>
        
        Estos implantes sustituyen a la raíz del diente colocándose:</p>
        
        <ul>
        <li>En el alvéolo del diente ausente si se pudiera colocar el mismo día de la exodoncia de la pieza</li>
        <li>En un lecho preparado quirúrgicamente a tal efecto para ello</li>
        </ul>
        <p>La osteointegración supone la unión, estructural y funcional entre el hueso vivo y la superficie de un implante sometido a carga funcional, 
        que <span>se consigue en el 95% de los casos.</span><br>
        Y, una vez constatado el éxito de la osteointegración del implante, se podrá realizar la fase protésica, mediante la cual se confeccionará, según el caso, 
        una corona unitaria o la restitución de varias o todas la piezas de una arcada, ya sea de forma fija o removible.<br><br>
        
        Previamente a la intervención quirúrgica se debe realizar un minucioso estudio radiográfico o tomográfico del paciente, para determinar la calidad y 
        cantidad de hueso, y así poder aconsejar el tratamiento a realizar con el mejor pronóstico posible, o en su defecto, descartar su realización.</p>`
    },{
        name:"Ortodoncia", 
        description: `<p>La ortodoncia es una especialidad de la odontología que se ocupa del diagnóstico, prevención y tratamiento de las malposiciones dentarias, 
        así como de las deformaciones de los maxilares.<br>
        
        Para ello el doctor deberá realizar un exhaustivo examen clínico, y mediante la toma de una serie de registros, tales como modelos dentales,
        fotografías faciales e intraorales y radiografías, le permitirán realizar un estudio adecuado y un plan de tratamiento personalizado.<br><br>
        
        <span>La duración del tratamiento siempre dependerá de las necesidades del caso</span>, la colaboración del paciente y de los objetivos que se deban 
        conseguir, y por este motivo, <span>puede ser variable.</span><br><br>
        
        La corrección de la posición de los dientes y de las bases óseas se realiza mediante una serie de aparatos que pueden ser fijos o removibles,
        dependiendo de cada caso.<br>
        Hoy en día disponemos de técnicas estéticas que permiten que los aparatos prácticamente no se aprecien.<br>
        En nuestra consulta estamos acreditados para la utilización de las técnicas de INVISALING como sistema mas novedoso de ortodoncia invisible.<br><br>
        
        Este tipo de tratamientos en la actualidad se pueden realizar a pacientes de todas las edades, siempre que las condiciones generales lo aconsejen.</p>`
    },{
        name:"Atención a pacientes especiales", 
        description: `<p>En nuestra consulta estamos capacitados para atender a pacientes especiales que presentan déficits físicos, psíquicos o de atención,
        procurando ofrecerles el tratamiento más adecuado a cada situación de la forma más cómoda posible para cada caso. <br><br>
        
        Asímismo, y siempre que sea posible, ofrecemos atención a pacientes ingresados en residencias u hospitales facilitando el tratamiento en el centro.</p>`
    },{
        name:"Cirugía bucal",
        description: `<p>Se dedica a la prevención, diagnóstico y tratamiento de las de las lesiones o patologías que afectan, tanto a las piezas dentales, como a los huesos maxilares
        y a los tejidos blandos adyacentes, y que para su resolución requieran de una intervención quirúrgica, pudiendo ir ésta desde una 
       simple toma de biopsia hasta tratarse de una intervención para la extracción de cordales (muelas 
       del juicio) o piezas retenidas, eliminación de frenillos, o eliminación de quistes y apicectomías de 
       piezas endodonciadas.<br>
       En otros casos permite la realización de injertos óseos o elevaciones de seno maxilar, como por ejemplo en situaciones en las que no fuera posible colocación
       de implantes, creando así unas mejores condiciones para el éxito.</p>`
    }
]



class ServicioItem extends React.Component {
 
    constructor(props){
        super(props)
        let { name, description } = props.item
        this.name = name
        this.description = description
        this.state = {isShowingModal: false}
    }

    handleClick = () => {
        console.log("Handle click");
        console.log(this);
        this.setState({isShowingModal: true})
    }

    handleClose = () => {
        console.log("Handle close");
        console.log(this)
        this.setState({isShowingModal: false})
    }

    render(){
        return (<li className="Servicio-Item" onClick={this.handleClick}>
            {this.name} <i className="fa fa-hand-o-up"></i>
            
            {this.state.isShowingModal && 
            <ModalContainer onClose={this.handleClose}>
                <ModalDialog onClose={this.handleClose} className="DIALOG">
                <h1>{this.name}</h1>
                <div dangerouslySetInnerHTML={{__html: this.description}}></div>
                </ModalDialog>
            </ModalContainer>}
        </li>)
    }
    
}

const ServicioList = ({items}) => (
    <ul className="Servicios-List">
        { items.map((e,i) => <ServicioItem key={i} item={e} />) }
    </ul>

)

const ServiciosComponent = () => (
    <div className="Servicios">

        <TitleContentSection title="Qué podemos ofrecerle" content="Nuestros 25 años de experiencia nos permiten ofrecerle un amplio abanico de tratamientos que intentaremos adecuar a cada caso." />
        
        <div className="Servicios-Content">

            <div className="Servicios-Content-Section Servicios-Content-Info">
                <MessageBox title="Servicios">
                    <div className="Servicios-Content-Info-Wrapper">
                        <p>Nuestra amplia experiencia nos permite ofrecer un amplio abanico de técnicas, con el objetivo de proporcionar al paciente exactamente lo que necesita.</p>
                        <p>Entre nuestros servicios se incluyen los siguientes:</p>

                        <div className="Servicios-List-Container">
                            
                            <ServicioList items={firstListItems} />
                            <ServicioList items={secondListItems} />
                        </div>
                    </div>
                </MessageBox>
            </div>

            <div className="Servicios-Content-Section Servicios-Content-Ventajas">
                <MessageBox title="Ventajas">
                    <ul className="Ventajas-List">
                        <li className="ventaja">Proximidad</li>
                        <li className="ventaja">Rapidez en el servicio</li>
                        <li className="ventaja">Amplitud de horarios</li>
                        <li className="ventaja">Máximo respeto al horario concertado</li>
                        <li className="ventaja">Múltiples especialidades</li>
                        <li className="ventaja">Medicina odontológica de calidad</li>
                    </ul>
                </MessageBox>
            </div>
        </div>
    </div>
)

const Servicios = BaseComponent(ServiciosComponent, "Servicios")

export default Servicios



// WEBPACK FOOTER //
// ./src/components/servicios/Servicios.js